module.exports = __webpack_public_path__ + "static/media/icon／icon_shangjiantou_1414_999999@3x.dded03ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon／icon_shangjiantou_1414_999999@3x.png
// module id = 1780
// module chunks = 0 1